var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{attrs:{"role":"none"}},[_c('v-list-item',{attrs:{"to":`/engage/${_vm.partner}/${_vm.link}`}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.text))])],1),_vm._v(" "),(_vm.showDivider)?_c('v-divider',{attrs:{"aria-hidden":"true"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }